const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

const canUseWindow = () => typeof window !== 'undefined' && Boolean(window.location);

export const resolveBackendBaseUrl = () => {
  const raw = String(process.env.REACT_APP_BACKEND_URL || '').trim();

  if (!canUseWindow()) return raw;

  if (!raw) return window.location.origin;

  try {
    const configured = new URL(raw, window.location.origin);
    const runningOnLocalhost = LOCAL_HOSTS.has(String(window.location.hostname || '').toLowerCase());
    const backendIsLocalhost = LOCAL_HOSTS.has(String(configured.hostname || '').toLowerCase());

    if (!runningOnLocalhost && backendIsLocalhost) {
      return window.location.origin;
    }

    return configured.origin;
  } catch {
    return window.location.origin;
  }
};

export const isJwtExpired = (token, skewSeconds = 30) => {
  try {
    if (!token) return true;
    const parts = String(token).split('.');
    if (parts.length < 2) return true;

    const payloadBase64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const paddedBase64 = payloadBase64.padEnd(payloadBase64.length + ((4 - (payloadBase64.length % 4)) % 4), '=');
    const payload = JSON.parse(atob(paddedBase64));
    const exp = Number(payload?.exp);
    if (!Number.isFinite(exp)) return false;

    const now = Math.floor(Date.now() / 1000);
    return now >= (exp - Math.max(0, Number(skewSeconds) || 0));
  } catch {
    return true;
  }
};

export const clearStaffSession = () => {
  try {
    const token = localStorage.getItem('ktc_token') || localStorage.getItem('access_token');
    if (token) {
      const base = resolveBackendBaseUrl();
      fetch(`${base}/api/auth/logout`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    // no-op
  }
  try {
    localStorage.removeItem('ktc_token');
    localStorage.removeItem('access_token');
    localStorage.removeItem('ktc_user');
    localStorage.removeItem('admin_user');
  } catch {
    // no-op
  }
};

export const clearCustomerSession = () => {
  try {
    const token = localStorage.getItem('ktc_customer_token');
    if (token) {
      const base = resolveBackendBaseUrl();
      fetch(`${base}/api/portal/logout`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    // no-op
  }
  try {
    localStorage.removeItem('ktc_customer_token');
    localStorage.removeItem('ktc_customer');
  } catch {
    // no-op
  }
};

export const requestStaffLogout = async () => {
  try {
    const token = localStorage.getItem('ktc_token') || localStorage.getItem('access_token');
    if (!token) return;
    const base = resolveBackendBaseUrl();
    await fetch(`${base}/api/auth/logout`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      keepalive: true,
    });
  } catch {
    // no-op
  }
};

export const requestCustomerLogout = async () => {
  try {
    const token = localStorage.getItem('ktc_customer_token');
    if (!token) return;
    const base = resolveBackendBaseUrl();
    await fetch(`${base}/api/portal/logout`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      keepalive: true,
    });
  } catch {
    // no-op
  }
};
